<section [formGroup]="formParent">
  <h3 class="ids-text-section-02 ids-pv-4">{{ title }}</h3>

  <section class="ids-row">
    <ids-shimmer class="ids-col-6" [show]="isLoading" height="5em">
      <ids-form-field class="ids-col-6" label="CEP" [errorMessage]="getCepFieldError(formControlNames[0], 'o CEP')">
        <input
          idsInput
          idsMask="99999-999"
          (input)="checkAddress({ clearFieldsOnError: true })"
          [formControlName]="formControlNames[0]"
        />
      </ids-form-field>

    </ids-shimmer>

    <ids-shimmer class="ids-col-6" [show]="isLoading" height="5em">
      <ids-form-field
        class="ids-col-6"
        label="endereço"
        [errorMessage]="getErrorMandatory('endereço')"
      >
        <input idsInput [formControlName]="formControlNames[4]"/>
      </ids-form-field>
    </ids-shimmer>


    <ids-form-field class="ids-col-6" label="número" [errorMessage]="getErrorMandatory('número')">
      <input
        idsInput
        type="numeric"
        oninput="this.value = this.value.replace(/[^0-9.]/g, '').replace(/(\..*?)\..*/g, '$1');"
        [formControlName]="formControlNames[5]"
      />
    </ids-form-field>

    <ids-form-field
      class="ids-col-6"
      label="complemento"
      [errorMessage]="getErrorMandatory('complemento')"
    >
      <input idsInput [formControlName]="formControlNames[6]"/>
    </ids-form-field>

    <ids-shimmer class="ids-col-6" [show]="isLoading" height="5em">
      <ids-form-field class="ids-col-6" label="bairro" [errorMessage]="getErrorMandatory('bairro')">
        <input idsInput [formControlName]="formControlNames[3]"/>
      </ids-form-field>
    </ids-shimmer>

    <ids-shimmer class="ids-col-6" [show]="citiesIsLoading || isLoading" height="5em">
      <ids-form-field label="cidade" class="ids-col-6" [errorMessage]="getErrorInvalid('cidade')">
        <ids-select class="ids-mt-2" [formControl]="formParent.get(this.formControlNames[2])">
          <ids-option *ngFor="let city of citiesOptions" [value]="city">
            {{ city }}
          </ids-option>
        </ids-select>
      </ids-form-field>
    </ids-shimmer>

    <ids-shimmer class="ids-col-6" [show]="isLoading" height="5em">
      <ids-form-field label="estado" class="ids-col-6" [errorMessage]="getErrorInvalid('estado')">
        <ids-select
          class="ids-mt-2"
          [formControl]="formParent.get(this.formControlNames[1])"
          (change)="handleChangeState($event)"
        >
          <ids-option
            *ngFor="let option of statesOptions"
            [value]="option.uf"
          >
            {{ option.state }}
          </ids-option>
        </ids-select>
      </ids-form-field>
    </ids-shimmer>






  </section>
</section>
